import "./scss/main.scss";
import "@splidejs/splide/css/core";
import "./js/instantPage";
import { initFontSize } from "./js/fontSize";
import { initHeroSlider } from "./js/heroSlider";
import { initPartnersSlider } from "./js/partnersSlider";
import { initMobileMenu } from "./js/mobileMenu";
import { initCountUp } from "./js/countUp";
import { initCalendar } from "./js/calendar";
import { initInstitutions } from "./js/institutions";
import { initLightbox } from "./js/lightbox";
import { initSearch } from "./js/search";
import { initCookieConsent } from "./js/cookieConsent";
import { initContactForm } from "./js/contactForm";
import { initFlipbook } from "./js/flipbook";

initFontSize();
initHeroSlider();
initPartnersSlider();
initMobileMenu();
initCountUp();
initCalendar();
initInstitutions();
initLightbox();
initSearch();
initCookieConsent();
initContactForm();
initFlipbook();
